import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[dev-label-func-host]',
})
export class DeviceLabelFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}